import { Ref, ref } from 'vue'

export default function useRemoteIcon (url: string): Ref<string> {
  const icon = ref('')
  if (!url) {
    return icon
  }

  fetch(url)
    .then(res => res.text())
    .then(content => {
      icon.value = content
    })
    .catch(() => {
      icon.value = ''
    })

  return icon
}
